module.exports = __webpack_public_path__ + "static/media/cloud-based.d933f5d4.svg";